export const fileType = (values) => {
    let fileType;
    if(values.order_withdrawal) {
        // Auftragsentzug
        fileType = 'order_withdrawal';
    } else if (values.defects_eliminated){
        // Freimeldung
        fileType = 'defects_eliminated';
    } else if(values.second_grace_period){
        // 2. Nachfrist
        fileType = 'second_grace_period';
    } else if(values.first_grace_period) {
        // 1. Nachfrist
        fileType = 'first_grace_period';
    } else if(values.deadline) {
        // Mangelanzeige
        fileType = 'deadline';
    } else {
        fileType = 'unknown';
    }

    return fileType;
}

export const fileData = (file, reference) => {

    let fileData = { name: file.sName || file.name};

    file.aRelations && file.aRelations.length && file.aRelations.forEach(relation => {
        if(relation[reference.label] === reference.id) {
            fileData.relation = relation;
            if(relation.alias) {
                fileData.name = relation.alias;
            }
        }
    });

    return fileData;
}
